import { useMount } from '@apia/util';
import { TToolbarIconButton } from './types';
import { Box, getVariant } from '@apia/theme';
import { ReactNode, useMemo } from 'react';
import { ToolbarController } from './ToolbarController';
import { ToolbarTextButton } from './ToolbarTextButton';
import { ToolbarIconButton } from './ToolbarIconButton';
import { ToolbarInput } from './ToolbarInput';
import { ToolbarSeparator } from './ToolbarSeparator';
import { ToolbarSelect } from './ToolbarSelect';

const Toolbar = ({
  children,
  getController,
}: {
  children: ReactNode;
  /**
   * El controlador permite gestionar el estado de los distintos elementos de
   * la toolbar
   */
  getController?: (newController: ToolbarController) => unknown;
}) => {
  const controller = useMemo(() => new ToolbarController(), []);

  useMount(() => {
    getController?.(controller);
  });

  return (
    <controller.Context>
      <Box
        className="toolbar"
        {...getVariant('layout.common.components.toolbar')}
      >
        {children}
      </Box>
    </controller.Context>
  );
};

export type { TToolbarIconButton as TToolDefinition };
export {
  ToolbarIconButton,
  ToolbarInput,
  ToolbarTextButton,
  Toolbar,
  ToolbarController,
  ToolbarSeparator,
  ToolbarSelect,
};
